import { render, staticRenderFns } from "./FeatureCardFixedAsset.vue?vue&type=template&id=a5f79a3a&"
import script from "./FeatureCardFixedAsset.vue?vue&type=script&lang=js&"
export * from "./FeatureCardFixedAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports